import React from "react";
import { ColumnValueRendererProps, RatingColumnValue } from "../table.data.interface";
import Star from "@mui/icons-material/Star";

const RatingColumn = ({ columnData, isPreview, otherBoardsValues }: ColumnValueRendererProps) => {
  const ratingValue = otherBoardsValues
    ? (columnData?.value as RatingColumnValue)?.rating
    : isPreview
      ? JSON.parse(columnData.value as string)?.rating
      : columnData.value
        ? columnData.value
        : 0; // Assuming this is a number from 1 to 5

  return (
    <div className="flex gap-1 items-center">
      {Array.from({ length: 5 }, (_, index) => {
        const isActive = index + 1 <= (ratingValue as number); // Determine if this star is active
        const color = isActive ? "#fdab3d" : "#c4c4c4"; // Blue if active, gray if not

        return (
          <div
            key={index}
            className={`flex gap-1 justify-center items-center p-1 rounded-full`}
            // Add padding and rounded corners for effect
            style={{ width: "16px", height: "16px", color: `${color}` }} // Set fixed size for the stars
          >
            <Star color="inherit" />
            {/* Change color based on active state */}
          </div>
        );
      })}
    </div>
  );
};

export default RatingColumn;
